import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

@Component<FilterMultipleLayout>({})
export default class FilterMultipleLayout extends Vue {

  // #region @PropSyncs

  @PropSync('filter')
  protected internalFilter!: string[];

  @PropSync('itemSearch')
  protected internalItemSearch!: string[];

  // #endregion

  // #region @Props

  @Prop({ default: 'Filteren' })
  protected applyFilterText!: string;

  @Prop({ default: 'Filters wissen' })
  protected clearFiltersText!: string;

  @Prop({ default: () => [] })
  protected items!: any[];

  @Prop({ default: 'Naam' })
  protected namePlural!: string;

  @Prop({ default: 'Zoek naar Naam' })
  protected placeholderSearch!: string;

  @Prop({ default: 'geselecteerd' })
  protected selectedText!: string;

  @Prop({ default: true })
  protected showSearchField!: boolean;

  // #endregion

  // #region Handlers

  protected onOrderFilter(): void {
    this.$emit('order-filter');
  }

  protected onResetFilter(): void {
    this.$emit('reset-filter');
  }

  // #endregion
}
